<template>
  <div class="sample">
    <el-row :gutter="10">
      <el-col :span="11">
        <span>任务书号：</span>
        <span>{{ operation.WEAVNO }}</span>
      </el-col>
      <el-col :span="11">
        <span>产品型号：</span>
        <span>{{ operation.PRODUCTID }}</span>
      </el-col>
      <!-- <el-col :span="6">
        <span>织造机台：</span>
        <span>{{ operation.WEAVDEVICEID }}</span>
      </el-col>
      <el-col :span="6">
        <span>对样人名称：</span>
        <span>{{ userName }}</span>
      </el-col> -->
    </el-row>
    <el-row :gutter="10">
      <!-- <el-col :span="6">
        <span>任务书号：</span>
        <span>{{ operation.WEAVNO }}</span>
      </el-col>
      <el-col :span="6">
        <span>产品型号：</span>
        <span>{{ operation.PRODUCTID }}</span>
      </el-col> -->
      <el-col :span="11">
        <span>织造机台：</span>
        <span>{{ operation.WEAVDEVICEID }}</span>
      </el-col>
      <el-col :span="11">
        <span>对样人名称：</span>
        <!-- <span>{{ userName }}</span> -->
        <el-select
          v-model="WorkersUsersID"
          clearable
          size="mini"
          filterable
          placeholder="请选择对样人"
          @change="changerUser"
        >
          <el-option
            v-for="item in personList"
            :key="item.PERSONID"
            :label="item.PERSONNAME"
            :value="item.PERSONID"
          />
        </el-select>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="11">
        <span>对样缸号：</span>
        <el-input v-model="operation.SUBBATCHNO" size="mini" @focus="open" />
      </el-col>
      <el-col :span="11">
        <span>对样结果：</span>
        <el-select
          v-model="operation.CHECKRESULT"
          clearable
          size="mini"
          placeholder="请选择"
        >
          <el-option
            v-for="item in sampleResults"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          />
        </el-select>
      </el-col>
      <!-- <el-col :span="12">
        <span>失败原因：</span>
        <el-input v-model="operation.ErrorResult" size="mini" />
      </el-col> -->
    </el-row>
    <el-row :gutter="10">
      <!-- <el-col :span="6">
        <span>对样缸号：</span>
        <el-input v-model="operation.SUBBATCHNO" size="mini" />
      </el-col>
      <el-col :span="6">
        <span>对样结果：</span>
        <el-select v-model="operation.CHECKRESULT" clearable size="mini" placeholder="请选择">
          <el-option v-for="item in sampleResults" :key="item.id" :label="item.label" :value="item.id" />
        </el-select>
      </el-col> -->
      <el-col :span="23">
        <span>失败原因：</span>
        <el-input
          v-model="operation.ErrorResult"
          size="mini"
          @focus="openShow"
        />
      </el-col>
    </el-row>
    <!-- 分割线 -->
    <!-- <el-row>
      <el-col :span="24">
        <el-divider></el-divider>
      </el-col>
    </el-row> -->
    <!-- button -->
    <!-- <el-row style="margin-bottom: 30px;">
      <el-col :span="24">
        <el-button type="primary" @click="addSampleCode" size="mini">+</el-button>
        <el-button type="primary" @click="deleteSampleCode" size="mini">-</el-button>
      </el-col>
    </el-row> -->
    <!-- table -->
    <el-row>
      <el-col :span="24">
        <el-table :data="operation.details" border style="width: 100%">
          <el-table-column prop="MATERIALID" label="原料编号">
          </el-table-column>
          <el-table-column prop="SIGN" label="经纬标志" width="100px">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.SIGN === 1">纬</el-tag>
              <el-tag type="danger" v-if="scope.row.SIGN === 0">经</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="ISUSEBATCHNO" label="用作编缸号" width="100px">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.ISUSEBATCHNO === 1"
                >是</el-tag
              >
              <el-tag type="danger" v-if="scope.row.ISUSEBATCHNO === 0"
                >否</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="MATERIALBATCHNO"
            label="纱线缸号"
            width="120px"
          >
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <Clavier v-if="show" :show="show" @updatekey="GetKeyVal"></Clavier>
    <Clavier v-if="show1" :show="show1" @updatekey="GetKeyErrVal"></Clavier>
  </div>
</template>
<script>
import localStorage from "@/api/localStorage";
import { api } from "../../api/index";
import { Notify } from "vant";
import storage from "../../api/storage";
import Clavier from "../../components/Clavier.vue";
export default {
  components: {
    Clavier,
  },
  props: {
    operation: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      show: false,
      show1: false,
      form: {
        SUBBATCHNO: "",
        SAMPLERESULT: 0,
        ErrorResult: "",
        CHECKRESULT: "",
      },
      tableData: [],
      WorkersUsersID: "",
      personList: [],
      sampleResults: [
        {
          id: 0,
          label: "合格",
        },
        {
          id: 1,
          label: "不合格",
        },
      ],
      signs: [
        {
          id: 0,
          label: "经",
        },
        {
          id: 1,
          label: "纬",
        },
      ],
      user: localStorage.getUser(),
    };
  },
  created() {
    this.CounterpartUser();
  },
  computed: {
    userName() {
      return this.user.UserId + "," + this.user.PersonName;
    },
  },
  methods: {
    open() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    GetKeyVal(val) {
      console.log(val);
      this.operation.SUBBATCHNO = val;
    },
    openShow() {
      this.show1 = false;
      this.$nextTick(() => {
        this.show1 = true;
      });
    },
    GetKeyErrVal(val) {
      console.log(val);
      this.operation.ErrorResult = val;
    },
    addSampleCowde() {
      this.tableData.push({
        SUBBATCHNO: "",
        CHECKRESULT: null,
        ErrorResult: "",
      });
    },
    deleteSampleCode() {
      this.tableData.pop();
    },

    changerUser(id) {
      console.log(id);
      this.personList.map((item) => {
        if (id === item.PERSONID) {
          this.WorkersUsersID = item.PERSONID;
          this.WorkersName = item.PERSONNAME;
        }
      });
      console.log(this.WorkersUsersID, this.WorkersName);
      storage.saveWorkersUsers({
        WID: this.WorkersUsersID,
        WName: this.WorkersName,
      });
      this.WorkersUsersID = storage.getWorkersUsers().WID;
      this.WorkersName = storage.getWorkersUsers().WName;
      console.log(this.WorkersName, this.WorkersUsersID);
    },
    CounterpartUser() {
      console.log(this.WorkersUsersID);
      api.CounterpartUser(this.WorkersUsersID).then((res) => {
        if (res.data.Success !== false) {
          this.personList = res.data;
          console.log(this.personList);
        } else {
          return Notify({ type: "danger", message: res.data.Message });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@deep: ~">>>";

.el-row {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;

  .el-col {
    display: flex;
    align-items: center;
    font-size: 0.23rem;

    span {
      white-space: nowrap;
    }
  }
}

@{deep} .el-table {
  .cell {
    height: 0.61333rem;
    line-height: 0.61333rem;
  }
}

@{deep} .el-tag {
  font-size: 0.25rem;
  height: 0.61333rem;
  line-height: 0.61333rem;
  padding: 0 0.2rem;
}
@{deep} .el-dialog--center .el-dialog__body {
  padding: 0.2rem 0.4rem !important;
}
</style>